import { useEffect, useState, useMemo } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import { productStocksListColumns } from "../../constant/tablesColumns/tablesColums";
import * as XLSX from "xlsx";
import Button from "../../components/common/button/Button";
import { convertDate } from "../../utils/convertDate";

export default function ProductStockList() {
  const [productData, setProductData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [inventoryStatusFilter, setInventoryStatusFilter] = useState("all");
  const [loadingExport, setLoadingExport] = useState(false);

  const transformData = (products) => {
    products = products.filter((item) => !item.hasVar && !item.isVar);
    return products?.map((item) => ({
      ...item,
      status: item.status === "active" ? "فعال" : "غیر فعال",
      inventoryStatus:
        item.inventoryStatus === "available" ? "موجود" : "ناموجود",
      inventoryStatusChangedAt: convertDate(item.inventoryStatusChangedAt),
    }));
  };

  const getProduct = async () => {
    const path = "admin/products/withSeparationVar";
    try {
      const response = await getApi({ path });
      const convertedData = transformData(response?.data?.result);
      setProductData(convertedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  const filteredAndSortedData = useMemo(() => {
    let data = [...productData];

    if (searchText) {
      const regex = new RegExp(searchText, "i");
      data = data.filter((item) => regex.test(item.name));
    }

    if (statusFilter !== "all") {
      data = data.filter((item) => item.status === statusFilter);
    }

    if (inventoryStatusFilter !== "all") {
      data = data.filter(
        (item) => item.inventoryStatus === inventoryStatusFilter
      );
    }
    return data;
  }, [productData, searchText, statusFilter, inventoryStatusFilter]);

  const handleExportExcel = () => {
    try {
      setLoadingExport(true);
      const exportData = filteredAndSortedData.map((item) => ({
        "نام محصول": item.name,
        "شناسه (SKU)": item.sku || "-",
        "وضعیت نمایش در سایت": item.status,
        "وضعیت موجودی": item.inventoryStatus,
        "آخرین تغییر موجودی": item.inventoryStatusChangedAt || "-",
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "ProductStocks");
      XLSX.writeFile(workbook, "product_stocks_export.xlsx");
    } catch (error) {
      console.log("Error exporting excel:", error);
    } finally {
      setLoadingExport(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <Title title={"لیست موجودی محصولات"} />
        <Button
          onClick={handleExportExcel}
          text={loadingExport ? "در حال دریافت..." : "خروجی اکسل"}
          color="success"
          type="button"
          className="whitespace-nowrap text-xs sm:text-sm"
        />
      </div>

      <div className="flex flex-col md:flex-row gap-4 flex-wrap">
        <input
          type="text"
          placeholder="جستجو نام محصول..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/3"
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/4"
        >
          <option value="all">همه وضعیت‌های نمایش</option>
          <option value="فعال">فقط فعال</option>
          <option value="غیر فعال">فقط غیر فعال</option>
        </select>

        <select
          value={inventoryStatusFilter}
          onChange={(e) => setInventoryStatusFilter(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/4"
        >
          <option value="all">بدون فیلتر موجودی</option>
          <option value="موجود">فقط موجود</option>
          <option value="ناموجود">فقط ناموجود</option>
        </select>
      </div>
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <div className="mr-4 flex flex-col sm:flex-row  ">
          <button className="text-white h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm   sm:w-auto px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {filteredAndSortedData?.length.toLocaleString()} عدد محصول
          </button>
        </div>
      </div>
      <Table columns={productStocksListColumns} rows={filteredAndSortedData} />
    </div>
  );
}
